<template>
  <div class="box6">
    <pageTitle
      title="阶梯式学习路径<br/>从零基础到AI开发工程师"
      text="课程紧贴企业刚需，从入门到精通，路径清晰，目标可见"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="path-list">
      <div
        class="path-item"
        v-for="(item, index) in pathList"
        :key="index"
        :class="{ 'path-item--active': item.isExpand }"
      >
        <div class="path-item__header" @click="togglePath(index)">
          <div class="path-item__title">
            <span class="path-item__tag">{{ item.tag }}</span>
            <span class="path-item__name">{{ item.title }}</span>
          </div>
          <img
            class="path-item__arrow"
            :class="{ 'path-item__arrow--up': item.isExpand }"
            src="../../../assets/coursePage/llm/box6/icon-down.png"
            alt=""
          />
        </div>

        <div class="path-item__content" v-show="item.isExpand && item.learnContent">
          <span class="path-item__number">{{ formatPathNumber(index) }}</span>

          <div class="path-item__section">
            <h4 class="path-item__label">学习内容</h4>
            <p class="path-item__text">{{ item.learnContent }}</p>
          </div>

          <div class="path-item__divider"></div>

          <div class="path-item__section">
            <h4 class="path-item__label">能力产出</h4>
            <p class="path-item__text">{{ item.ability }}</p>
          </div>

          <div class="path-item__divider"></div>

          <div class="path-item__section path-item__section--job">
            <div class="path-item__job-left">
              <h4 class="path-item__label">胜任岗位</h4>
              <p class="path-item__job">{{ item.job }}</p>
            </div>
            <p class="path-item__salary">{{ item.salary }}</p>
          </div>
        </div>
      </div>
    </div>

    <ConsultBtn text="获取详细课程大纲" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
  data() {
    return {
      pathList: [
        {
          tag: "路径一",
          title: "AI大模型开发入门",
          isExpand: true,
          learnContent:
            "Python基础语法、数据处理、Ollama本地部署、私有化大模型搭建、ChatBot聊天机器人实战",
          ability:
            "能独立调用大模型API，完成简单AI应用开发，理解大模型核心原理与应用",
          job: "初级AI开发工程师",
          salary: "10-12K",
          slogan: "夯实AI编程基础 建立AI认知",
        },
        {
          tag: "路径二",
          title: "大模型应用开发",
          isExpand: false,
          learnContent:
            "Python进阶编程、数据处理与统计分析、NumPy/Pandas数据工具、Prompt工程、Coze/Dify平台开发",
          ability:
            "不写复杂代码，也能快速构建对话机器人、知识库问答等智能体应用",
          job: "智能体平台开发工程师/Coze/Dify开发工程师",
          salary: "10-14K",
          slogan: "掌握低代码快速开发 建立实战信心",
        },
        {
          tag: "路径三",
          title: "大模型核心开发技术",
          isExpand: false,
          learnContent:
            "机器学习基础、深度学习、PyTorch框架、Transformer原理、NLP基础、BERT/GPT架构",
          ability:
            "理解模型训练与微调逻辑，能运行训练代码，能读懂技术论文",
          job: "机器学习工程师/深度学习工程师",
          salary: "15-18K",
          slogan: "彻底理解AI底层算法 攻克技术核心",
        },
        {
          tag: "路径四",
          title: "大模型智能体开发",
          isExpand: false,
          learnContent:
            "LangChain/LangGraph框架、向量数据库（Milvus/PGVector）、RAG检索增强、智能体高阶开发",
          ability:
            "能为企业构建专属知识库问答系统，解决大模型“幻觉”问题",
          job: "Agent开发工程师/智能体全栈开发工程",
          salary: "18-20K",
          slogan: "工程化落地能力 企业级实战应用",
        },
        {
          tag: "路径五",
          title: "大模型定制开发",
          isExpand: false,
          learnContent:
            "Transformer原理、迁移学习、大模型微调与部署、OpenAI/DeepSeek大模型生态、多智能体协作",
          ability:
            "开发能自主决策、调用API、完成复杂任务的AI智能体",
          job: "大模型开发工程师/算法工程师/大模型训练工程师",
          salary: "20-35K",
          slogan: "系统架构与优化 高阶技术深耕",
        },
        {
          tag: "路径六",
          title: "大模型算法进阶",
          isExpand: false,
          learnContent:
            "CV图像分析、多模态大模型、文生图（Stable Diffusion）、图文检索、NLP/CV专题技术",
          ability:
            "能开发图像分析、文生图、跨模态检索等多模态应用，实现垂直领域模型定制",
          job: "CV算法工程师/图像处理工程师/多模态大模型工程师",
          salary: "20-35K",
          slogan: "赋能业务场景 高阶能力升级",
        },
      ],
    };
  },
  methods: {
    formatPathNumber(index) {
      return String(index + 1).padStart(2, "0");
    },
    togglePath(index) {
      const target = this.pathList[index];
      const willExpand = !target.isExpand;
      this.pathList.forEach((item, i) => {
        item.isExpand = i === index ? willExpand : false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;



  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 44px;
    margin-top: 14px;
  }

  .path-list {
    position: relative;
    z-index: 1;
    margin-top: 48px;
  }

  .path-item {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 88px;
      padding: 0 36px;
      border-radius: 20px;
      background: linear-gradient(270deg, #85b4ff 0%, #2579ff 100%);
      cursor: pointer;
    }

    &__title {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    &__tag {
      flex-shrink: 0;
      margin-right: 24px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 600;
      color: #ffffff;
      line-height: 44px;
    }

    &__name {
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 600;
      color: #ffffff;
      line-height: 44px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__arrow {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      transition: transform 0.3s ease;

      &--up {
        transform: rotate(180deg);
      }
    }

    &__content {
      position: relative;
      margin-top: 16px;
      padding: 32px 32px 40px;
      border-radius: 20px;
      background: linear-gradient( 129deg, rgba(247,253,255,0) 0%, rgba(247,253,255,0) 40%, #D4ECFF 100%);
      box-shadow: inset 0 14px 10px rgba(202, 231, 255, 1);
      overflow: hidden;
    }

    &__number {
      position: absolute;
      top: 0;
      right: 24px;
      z-index: 0;
      font-family: SourceHanSansSC, SourceHanSansSC;
font-weight: 800;
font-size: 112px;
color: #FFFFFF;
line-height: 112px;
text-align: right;
font-style: normal;
      opacity: 0.7;
 
    }

    &__section {
      position: relative;
      z-index: 1;

      &--job {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }
    }

    &__label {
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-size: 26px;
      font-weight: 600;
      color: #072557;
      line-height: 36px;
    }

    &__text {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #0f2654;
      line-height: 36px;
    }

    &__divider {
      height: 2px;
      margin: 24px 0;
      border-bottom:2px dashed #B2C8DD;
      
    }

    &__job-left {
      flex: 1;
      min-width: 0;
    }

    &__job {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #072557;
      line-height: 40px;
    }

    &__salary {
      flex-shrink: 0;
      margin-left: 24px;
      font-family: PingFangSC, PingFang SC;
      font-size: 44px;
      font-weight: 600;
      color: #0159e7;
      line-height: 66px;
    }

    &__slogan {
      position: relative;
      z-index: 1;
      margin-top: 24px;
      padding: 16px 24px;
      border-radius: 12px;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 500;
      color: #072557;
      line-height: 36px;
      text-align: center;
      background: rgba(212, 236, 255, 0.6);
    }
  }

}
</style>
